// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c3088f07","453":"2b4fc598","732":"573a4b03","977":"adfecebe"}[chunkId] + ".chunk.js";
};